import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { ContactInfo } from './ContactInfo';

export const Help: FC = () => {
  const t = useTranslations();

  return (
    <div className="mt-8 flex flex-col items-center justify-center gap-3">
      <div className="text-base">{t('payments.mySubscription.needHelp')}</div>
      <ContactInfo />
    </div>
  );
};
